import { Dialog, IconButton, Stack, Typography, styled } from '@mui/material';
import translations from 'utils/translations';
import React from 'react';
import { useIntl } from 'react-intl';

import CloseIcon from '@mui/icons-material/Close';
import ModalContent from './ModalContent';

const AddDialog = ({ isOpen, onClose, onAccept, locale, loggedUser }) => {
  const intl = useIntl();
  const i18nRecap = translations.TicketsV2(intl).Recap;
  const StyledDialog = styled(Dialog)({
    '& .MuiPaper-root': {
      borderRadius: '16px',
    },
  });
  return (
    <StyledDialog
      onClose={onClose}
      open={isOpen}
      maxWidth={'lg'}
      id="add-menu"
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ padding: '30px' }}>
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-end'}
        >
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Typography variant="m-bold" sx={{ mb: '25px' }}>
          {i18nRecap.dialogTitle}
        </Typography>
        <ModalContent
          locale={locale}
          onAccept={onAccept}
          loggedUser={loggedUser}
        />
      </div>
    </StyledDialog>
  );
};
export default AddDialog;
